import icBtnArrow2SPSP2x from 'assets/images/SP/@2x/ic_btn_arrow2_sp@2x.png';
import icMenuSP2x from 'assets/images/SP/@2x/ic_menu@2x.png';
import icMenuCloseSP2x from 'assets/images/SP/@2x/ic_menu_close@2x.png';
import imgHoshinoLogoSP2x from 'assets/images/SP/@2x/img_hoshino_logo@2x.png';
import icBtnArrow2SPSP3x from 'assets/images/SP/@3x/ic_btn_arrow2_sp@3x.png';
import icMenuSP3x from 'assets/images/SP/@3x/ic_menu@3x.png';
import icMenuCloseSP3x from 'assets/images/SP/@3x/ic_menu_close@3x.png';
import imgHoshinoLogoSP3x from 'assets/images/SP/@3x/img_hoshino_logo@3x.png';
import Button from 'components/common/Button';
import Image from 'components/common/Image';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import MediaBorders from 'constants/media-borders';
import i18n from 'i18n';
import moment from 'moment';
import React from 'react';
import Media from 'react-media';
import { NavLink } from 'react-router-dom';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';


const CommonTemplate = ({ className, maintenanceFlg }) => (
  <div className={className}>
    <ul>
      <li>
        <NavLink to="/about/payment">
          {i18n.t('common:header.aboutPayment')}
          <Image
            pc1x={icBtnArrow2SPSP2x}
            pc2x={icBtnArrow2SPSP2x}
            sp2x={icBtnArrow2SPSP2x}
            sp3x={icBtnArrow2SPSP3x}
            alt="ic_btn_arrow2_sp"
          />
        </NavLink>
      </li>
      <li>
        <NavLink to="/about/delivery">
          {i18n.t('common:header.aboutDelivery')}
          <Image
            pc1x={icBtnArrow2SPSP2x}
            pc2x={icBtnArrow2SPSP2x}
            sp2x={icBtnArrow2SPSP2x}
            sp3x={icBtnArrow2SPSP3x}
            alt="ic_btn_arrow2_sp"
          />
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName="active" to="/mypage/login">
          {i18n.t('common:header.checkFromOrderNumber')}
          <Image
            pc1x={icBtnArrow2SPSP2x}
            pc2x={icBtnArrow2SPSP2x}
            sp2x={icBtnArrow2SPSP2x}
            sp3x={icBtnArrow2SPSP3x}
            alt="ic_btn_arrow2_sp"
          />
        </NavLink>
      </li>
      <li>
        <NavLink to="/faq">
          {i18n.t('common:header.faq')}
          <Image
            pc1x={icBtnArrow2SPSP2x}
            pc2x={icBtnArrow2SPSP2x}
            sp2x={icBtnArrow2SPSP2x}
            sp3x={icBtnArrow2SPSP3x}
            alt="ic_btn_arrow2_sp"
          />
        </NavLink>
      </li>
    </ul>
    <ul className="gift-contents">
      <li>
        <NavLink to="/about/gift">
          {i18n.t('common:header.aboutGift')}
          <Image
            pc1x={icBtnArrow2SPSP2x}
            pc2x={icBtnArrow2SPSP2x}
            sp2x={icBtnArrow2SPSP2x}
            sp3x={icBtnArrow2SPSP3x}
            alt="ic_btn_arrow2_sp"
          />
        </NavLink>
      </li>
    </ul>
    <div className="purchase-btn">
      <NavLink to="/order-aggregators/purchase">
        <Button buttonType="B" className="purchase-gift" disabled={maintenanceFlg}>
          {i18n.t('common:header.purchaseGiftCard')}
        </Button>
      </NavLink>
    </div>
    <div className="hoshino-logo">
      <a href="https://hoshinoresorts.com/jp/">
        <Image
          pc1x={imgHoshinoLogoSP2x}
          pc2x={imgHoshinoLogoSP2x}
          sp2x={imgHoshinoLogoSP2x}
          sp3x={imgHoshinoLogoSP3x}
          alt="ic_btn_arrow2_sp"
        />
      </a>
    </div>
  </div>
);

// メンテナンス時刻チェック
function isMaintenanceNow() {
  const begin = i18n.t('notice:maintenance.begin');
  return begin && moment(begin).diff(moment()) < 0;
}

class PCHeaderNav extends React.Component {
  constructor(props) {
    super(props);
    // メンテナンス時刻チェック処理
    const timer = i18n.t('notice:maintenance.begin') && setInterval(() => {
      this.setState({ maintenanceFlg: isMaintenanceNow() });
    }, 1000);
    this.state = {
      maintenanceFlg: isMaintenanceNow(),
      timer,
    };
  }

  componentWillUnmount() {
    if (this.state.timer) {
      clearInterval(this.state.timer);
    }
  }

  render() {
    const { className } = this.props;
    const { maintenanceFlg } = this.state;
    return <CommonTemplate className={className} maintenanceFlg={maintenanceFlg} />;
  }
}

class SPHeaderNav extends React.Component {
  constructor(props) {
    super(props);
    // メンテナンス時刻チェック処理
    const timer = i18n.t('notice:maintenance.begin') && setInterval(() => {
      this.setState({ maintenanceFlg: isMaintenanceNow() });
    }, 1000);
    this.state = {
      dropdownOpened: false,
      maintenanceFlg: isMaintenanceNow(),
      timer,
    };
  }

  componentWillUnmount() {
    if (this.state.timer) {
      clearInterval(this.state.timer);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.closeNav();
    }
  }

  closeNav = () => {
    this.setState({ dropdownOpened: false });
  };

  handleClickToggle = () => {
    this.setState({ dropdownOpened: !this.state.dropdownOpened }, () => {
      if (this.state.dropdownOpened) {
        this.props.closeAlert();
      }
    });
  };

  render() {
    const { className } = this.props;
    const { maintenanceFlg } = this.state;

    return (
      <nav className={className}>
        <div className="contents">
          {this.state.dropdownOpened ? (
            ''
          ) : (
              <div>
                <NavLink to="/order-aggregators/purchase">
                  <Button buttonType="B" className="purchase-gift" disabled={maintenanceFlg}>
                    {i18n.t('common:header.purchaseGiftCard')}
                  </Button>
                </NavLink>
              </div>
            )}

          <div
            className={`dropdown ${
              this.state.dropdownOpened ? 'opened' : 'closed'
              } `}
          >
            <button type="button" onClick={this.handleClickToggle}>
              {this.state.dropdownOpened ? (
                <Image
                  pc1x={icMenuCloseSP2x}
                  pc2x={icMenuCloseSP2x}
                  sp2x={icMenuCloseSP2x}
                  sp3x={icMenuCloseSP3x}
                  alt="ic_menu"
                />
              ) : (
                  <Image
                    pc1x={icMenuSP2x}
                    pc2x={icMenuSP2x}
                    sp2x={icMenuSP2x}
                    sp3x={icMenuSP3x}
                    alt="ic_menu"
                  />
                )}
            </button>
          </div>
        </div>

        <div
          className={`${
            this.state.dropdownOpened ? 'opened' : 'closed'
            } dropdown-overlay`}
          onClick={this.closeNav}
        >
          <CommonTemplate className="dropdown-list" maintenanceFlg={maintenanceFlg} />
        </div>
      </nav>
    );
  }
}

const commonStyle = css`
  a {
    text-decoration: none;
  }

  ul {
    padding-left: 0;
    margin: 0;

    li {
      list-style: none;

      a {
        color: inherit;

        &:hover {
          color: ${Colors.orange1};
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
  }

  .active {
    color: ${Colors.orange1};
    font-weight: bold;
  }

  .purchase-gift {
    width: 142px;
    height: 40px;
    color: ${Colors.white1};
    ${FontStyles.text9};
    cursor: pointer;
  }
`;

const pcStyle = css`
  display: flex;
  justify-content: flex-end;

  ul {
    position: relative;
    display: flex;
    justify-content: flex-end;

    &:first-child {
      &:after {
        content: ' ';
        position: absolute;
        right: 0;
        top: 8px;
        height: 24px;
        border: 0;
        border-right: 1px solid ${Colors.gray2};
        margin: 0;
      }
    }
  }

  li {
    display: flex;
    justify-content: center;
    align-items: center;
    ${FontStyles.text10};
    color: ${Colors.black1};
    padding: 0 12px;

    &.purchase-gift {
      margin: 0 12px;
    }

    &:first-child {
      padding-left: 24px;
    }

    &:last-child {
      padding-right: 24px;
    }

    picture {
      display: none;
    }
  }

  .hoshino-logo {
    display: none;
  }
`;

const spStyle = css`
  height: 100%;

  .contents {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .purchase-gift {
    width: 90px;
    height: 32px;
    ${FontStyles.text7};
  }

  .dropdown {
    display: inline-block;
    position: relative;

    &.closed:before {
      content: ' ';
      position: absolute;
      left: 0;
      top: 5px;
      height: 24px;
      border: 0;
      border-right: 1px solid ${Colors.gray2};
      margin: 0;
    }

    button {
      padding: 0 0 0 16px;
      border: none;
      outline: none;
      background-color: transparent;
    }
  }

  .dropdown-overlay {
    position: fixed;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    background-color: ${Colors.white1};
    transition: visibility 0.35s ease;
    visibility: hidden;

    .dropdown-list {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.5s 0s ease;
      background-color: ${Colors.white1};
      padding: 1px 16px 24px;
    }

    &.opened {
      visibility: visible;

      .dropdown-list {
        max-height: 470px;
        border-top: 1px solid ${Colors.gray2};
        background-color: ${Colors.white1};
      }
    }
  }

  ul {
    ${FontStyles.text8};

    &:first-child {
      border-bottom: 1px solid ${Colors.black1};
    }

    li {
      height: 56px;
      line-height: 56px;
      color: ${Colors.black1};
      border-bottom: 1px solid ${Colors.gray3};

      &:last-child {
        border-bottom: 1px solid transparent;
      }

      a {
        display: block;
      }

      picture {
        float: right;
      }
    }
  }

  .gift-contents {
    li {
      height: 72px;
      line-height: 72px;
    }
  }

  .purchase-btn {
    margin-bottom: 24px;
    .purchase-gift {
      margin: 0;
      width: 100%;
      height: 56px;
    }
  }

  .hoshino-logo {
    height: 56px;
    background-color: ${Colors.black1};

    a {
      display: inline-block;
      width: 100%;
      height: 100%;
      position: relative;

      picture > img {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }
`;

const StyledPCHeaderNav = applyStyles(PCHeaderNav)(commonStyle, pcStyle);
const StyledSPHeaderNav = applyStyles(SPHeaderNav)(commonStyle, spStyle);

export default props => (
  <Media
    query={`(min-width: ${MediaBorders.umedium})`}
    children={matches =>
      matches ? <StyledPCHeaderNav /> : <StyledSPHeaderNav {...props} />
    }
  />
);



// WEBPACK FOOTER //
// ./src/components/common/Header/components/HeaderNav.js